/** True when every word in the query appears in the haystack.
 *  Spaces and punctuation inside a word are ignored, so "20cu" matches "20 CU".
 */
export function matchesLooseCatalogQuery(haystack: string, query: string): boolean {
  const tokens = query
    .toLowerCase()
    .split(/\s+/)
    .map((token) => token.replace(/[^a-z0-9]/g, ""))
    .filter(Boolean);
  if (tokens.length === 0) return true;
  const hay = haystack.toLowerCase().replace(/[^a-z0-9]/g, "");
  return tokens.every((token) => hay.includes(token));
}
